const getPaxSummary = party =>
  party
    .filter(group => group.value > 0)
    .map(group => `${group.value} ${group.label}`)
    .join(', ') || ''

export default getPaxSummary
